module.exports = {
    token : '0xc52c326331e9ce41f04484d3b5e5648158028804',
    holderToken: '0xf94415d7e639951b79e75d5849bae286b664ec3a',
    pToken: '0xDD75542611D57C4b6e68168B14C3591C539022eD',
    pHolderToken: '0x90acE14eb654d5f6a67c0975F84a1B3F29Dc28f1'
};